<app-header></app-header>

<router-outlet></router-outlet>

<app-footer></app-footer>


// WEBPACK FOOTER //
// ./src/app/body/body.component.html